
import Common from './common/common';
import Recipe from './common/recipe';

////
const Init = () => {

	Common();
	Recipe();

}

Init();
